export const getRandomNumberByRange = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;
